<div class="container">
      <section class="inner-container">
        <main>
          <div class="contact-form" style="background-image: url(images/login-bg.jpg); background-size: cover; height: 80vh; padding-top: 9vh">
            <div class="row">
              <div class="col-md-4">
              </div>
              <!--; margin-left: 3em; margin-right: 3em; max-width: 500px-->
              <div class="col-md-4" style="border-radius: 25px; background: white; opacity: 0.9; padding: 3em">
                <form name="password-form" id="password-form" data-k2-validation="true" novalidate class="general-form">
                  <h5 class="title-form">Reset password</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="password" name="password" id="password" [(ngModel)]="password" placeholder="" class="custom-input" required data-rules="required|password" data-error-mes="This field is required|Password must contain at least 8 characters, including at least 1 number AND at least 1 uppercase letter.">
                        <label>Password</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                            <input type="password" name="confirmPassword" id="confirmPassword" [(ngModel)]="confirmPassword" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required">
                        <label>Confirm Password</label>
                      </div>
                      <div *ngIf="!passwordValid" class="error">
                        <div [hidden]="!((password && password.value) || (confirmPassword && confirmPassword.value))">
                          Passwords do not match
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group mid">
                      <button type="submit" class="btn btn-primary" (click)="validatePassword(password,confirmPassword)">Submit</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>

